import { buildAxiosClient } from '../../../common/models/axiosClient';
import type { AxiosPromise, GenericAbortSignal } from 'axios';
import type { Project } from './project';

export default class ProjectClient {
  fetchAll(
    page: number,
    keyword: string | null,
    order: string | null,
    signal?: GenericAbortSignal,
  ): AxiosPromise<Project[]> {
    return buildAxiosClient().get('/api/v1/projects/stagings.json', {
      params: {
        page: page,
        keyword: keyword,
        order: order,
      },
      signal: signal,
    });
  }
}
